import { useCallback, useEffect, useState } from "react";

import { getConversation } from "../api/sdk.gen.ts";
import { CopilotConversation, CopilotMessage } from "../api/types.gen.ts";

export const useConversationHistory = (
  sessionId: string,
): {
  error: null | string;
  isLoading: boolean;
  loadConversation: () => Promise<void>;
  messages: CopilotMessage[];
} => {
  const [error, setError] = useState<null | string>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [conversation, setConversation] = useState<CopilotConversation | null>(
    null,
  );
  const loadConversation = useCallback(async (): Promise<void> => {
    setIsLoading(true);
    setError(null);
    try {
      const getResponse = await getConversation({
        body: { sessionId },
      });
      if (getResponse.data) {
        setConversation(getResponse.data);
      }
    } catch (error) {
      console.error("Failed to create conversation:", error);
      const body = error as { message?: string } | null | undefined;
      setError(
        body?.message?.trim() ??
          "Unknown error occurred while fetching conversation history",
      );
    } finally {
      setIsLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    void loadConversation();
  }, [loadConversation]);

  return {
    error,
    isLoading,
    loadConversation,
    messages: conversation ? conversation.messages : [],
  };
};
